import React from "react";
import { NavLink } from "react-router-dom";
import "./Sidebar.css";

// import projectMasterIcon from "../../assets/icons/project-master.png";
// import arrowDownIcon from "../../assets/icons/arrow-down.svg";

const menuItems = [
  {
    path: "/airportmaster",
    label: "Airport Master",
    // icon: projectMasterIcon,
  },
  {
    path: "/airlinemaster",
    label: "Airline Master",
    // icon: airlineIcon,
  },
  {
    path: "/usermaster",
    label: "User Master",
    // icon: airlineIcon,
  },
];

const Sidebar = ({ isOpen }) => {
  return (
    <aside className={`navigation ${isOpen ? "open" : "closed"}`}>
      <ul className="nav-menu">
        {menuItems.map((item) => (
          <li key={item.path} className="nav-item">
            <NavLink
              to={item.path}
              end
              className={({ isActive }) =>
                `nav-item-btn ${isActive ? "active" : ""}`
              }
            >
              {/* ICON */}
              {/* <span className="nav-icon">
                <img src={item.icon} alt={item.label} />
              </span> */}

              {/* TEXT */}
              <span className="nav-text">{item.label}</span>

              {/* ARROW */}
              <span className="nav-arrow">
                <img src="#" alt="expand" />
              </span>
            </NavLink>
          </li>
        ))}
      </ul>
    </aside>
  );
};

export default Sidebar;